import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, catchError, map, throwError } from 'rxjs';
import { RoleViewService } from './role-view.service';
const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
}
@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  private _selectedProject: any;
  pathUrl = environment?.baseApiUrl + environment?.dashboardApiPath;
  userIdentifier = '';
  userUuid = '';
  
  constructor(private readonly http: HttpClient,  private readonly _roleViewService:RoleViewService) { 
    this._roleViewService.getUserName$().subscribe(name => {
      this.userIdentifier = name;
    });
    this._roleViewService.getUserUuid$().subscribe(uuid => {
      this.userUuid = uuid;
    });

  }

  fetchDashboardData(daysFilter: string): Observable<any> {
    const url = `${this.pathUrl}fetchDashboardsDetails${environment?.proxy}?daysFilter=${daysFilter}`;
    return this.http
      .get(url, httpOptions)
      .pipe(map((response: any) => response));
  }
  fetchProjectDraftDetails(projectId: string): Observable<any> {
    const url = `${this.pathUrl}fetchProjectDraftDetails${environment?.proxy}?projectId=${projectId}`;
    return this.http
      .get(url, httpOptions)
      .pipe(map((response: any) => response));
  }

  fetchSelectedPrjDeptTeamMembers(projectId: string, departmentId: string): Observable<any> {
    const url = `${this.pathUrl}fetchSelectedPrjDeptTm${environment?.proxy}?projectId=${projectId}&departmentId=${departmentId}`;
    return this.http.get(url).pipe(
      map((response: any) => response?.payload || []),
      catchError(this.handleError)
    );
  }

  updateDepartmentTaskAssignee(_workDayId: string, request: any): Observable<any> {
    const url = `${this.pathUrl}updateDepartmentTaskAssignee${environment?.proxy}?userIdentifier=${this.userIdentifier}&workDayId=${this.userUuid}`;
    return this.http.post(url, request, httpOptions).pipe(
      map((response: any) => response),
      catchError(this.handleError.bind(this))
    );
  }

  
  deleteProjectDetails(_workDayId: string, request: any): Observable<any> {
    const url = `${this.pathUrl}deleteProjectDetails${environment?.proxy}?userIdentifier=${this.userIdentifier}&workDayId=${this.userUuid}`;
    return this.http.post(url, request, httpOptions).pipe(
      map((response: any) => response),
      catchError(this.handleError.bind(this))
    );
  }

  fetchActivityStream(projectId: string, departmentId?: string): Observable<any> {
    let url = `${this.pathUrl}fetchActivityStream${environment?.proxy}?projectId=${projectId}`;
    if (departmentId) {
      url += `&departmentId=${departmentId}`;
    }
    return this.http.get(url, httpOptions).pipe(
      map((response: any) => response),
      catchError(this.handleError.bind(this))
    );
  }

  sendEmailReminder(_workDayId: string, request: any): Observable<any> {
    const url = `${this.pathUrl}sendReminderHandler${environment?.proxy}?userIdentifier=${this.userIdentifier}&workDayId=${this.userUuid}`;
    return this.http.post(url, request, httpOptions).pipe(
      map((response: any) => response),
      catchError(this.handleError.bind(this))
    );
  }

  postActivityComments(_workDayId: string, request: any): Observable<any> {
    const url = `${this.pathUrl}addActivityComments${environment?.proxy}?userIdentifier=${this.userIdentifier}&workDayId=${this.userUuid}`;
    return this.http.post(url, request, httpOptions).pipe(
      map((response: any) => response),
      catchError(this.handleError.bind(this))
    );
  }

  fetchUploadedDocuments(projectId: string, departmentId?: string): Observable<any> {
    let url = `${this.pathUrl}fetchUploadedDocuments${environment?.proxy}?userIdentifier=${this.userIdentifier}&projectId=${projectId}`;
    if (departmentId) {
      url += `&departmentId=${departmentId}`;
    }
    return this.http.get(url, httpOptions).pipe(
      map((response: any) => response),
      catchError(this.handleError.bind(this))
    );
  }

  setSelectedProject(projectForm: any) {
    this._selectedProject = projectForm;
    console.info("project", projectForm)
  }
  getSelectedProject(): any {
    return this._selectedProject;
  }

  // ===================================== Exception Handler ===========================================

  private handleError(error: HttpErrorResponse) {
    let errorMsg = '';
    if (error.error instanceof ErrorEvent) {
      //A client-side or network error occurred. Handle it accordingly.
      errorMsg = `An error occurred: ${error.error.message}`;
    } else {
      //The backend returned an unsuccessful response code.
      //The response body may contain clues as to what went wrong,
      errorMsg = `Backend returned code ${error.status}`;
    }
    //return an observable with a user-facing error message
    return throwError(() => new Error(errorMsg));
  }
  getUserName(): string {
    try {
      const stored = sessionStorage.getItem('UserInfo');  
      if (stored) {
        const userInfo = JSON.parse(stored);
        return userInfo?.userName || '';
      }
    } catch (error) {
      console.trace('Error parsing user info from session storage', error);
    }
    return '';
  }
  }
